/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import {Col, Row} from 'react-bootstrap';
import RewardChart from './reward-chart';
import './reward-chart.css';
import t from '../../../data/translations';

class RewardChartWithCaption extends Component {
  render() {
    const {rewardMarkup} = this.props;
    return (
      <Row className="staff-reward-chart">
        <Col lg={4} className="pie-chart">
          <RewardChart
            personalRewardsPercent={rewardMarkup / 100.0}
            staffRewardsPercent={(100.0 - rewardMarkup) / 100.0}
          />
        </Col>
        <Col lg={8} className="slice-details">
          <div>
            <span className="slice-percent green">{100 - (rewardMarkup || 0)}%</span>
            <span className="slice-title">{ t('staffRewards') }</span>
            <span className="slice-caption green"/>
          </div>
          <div>
            <span className="slice-percent red">{rewardMarkup || 0}%</span>
            <span className="slice-title">Personal Rewards</span>
            <span className="slice-caption red"/>
          </div>
        </Col>
      </Row>
    );
  }
}

export default RewardChartWithCaption;



// WEBPACK FOOTER //
// ./src/components/common/outlet/reward-chart-with-caption.jsx